import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/shared/store/hooks';
import { POST_LOGOUT_REDIRECT_KEY } from '@/shared/lib/auth/clearClientSession';

function peekPostLogoutRedirect(): string | null {
  try {
    return sessionStorage.getItem(POST_LOGOUT_REDIRECT_KEY);
  } catch {
    return null;
  }
}

/** Blocks unauthenticated access to private routes. */
export function AuthGuard() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    // Peek only — do not remove here (Strict Mode double-render would lose signup).
    const postLogoutTo = peekPostLogoutRedirect();
    if (postLogoutTo) {
      return <Navigate to={postLogoutTo} replace />;
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
